<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 168 150"
    style="enable-background: new 0 0 168 150"
    xml:space="preserve"
  >
    <g></g>
    <g></g>
    <g class="st0"></g>
    <g>
      <g>
        <g>
          <path
            class="st1"
            d="M113.2,24c0.3-1.3,0.5-2.6,0.5-4c0-9-7.3-16.3-16.3-16.3c-5.5,0-10.4,2.7-13.3,6.9
                c-2.9-4.2-7.8-6.9-13.3-6.9c-9,0-16.3,7.3-16.3,16.3c0,1.4,0.2,2.7,0.5,4c-7.8,1.2-13.8,7.9-13.8,16.1c0,9,7.3,16.3,16.3,16.3
                c5.5,0,10.4-2.7,13.3-6.9c2.9,4.2,7.8,6.9,13.3,6.9c5.5,0,10.4-2.7,13.3-6.9c2.9,4.2,7.8,6.9,13.3,6.9c9,0,16.3-7.3,16.3-16.3
                C127.1,31.9,121.1,25.2,113.2,24z"
          />
          <path
            class="st2"
            d="M110.8,59.4c-5,0-9.8-2-13.3-5.3c-3.6,3.4-8.3,5.3-13.3,5.3s-9.8-2-13.3-5.3c-3.6,3.4-8.3,5.3-13.3,5.3
                c-10.6,0-19.3-8.6-19.3-19.3c0-8.4,5.6-15.8,13.4-18.4c-0.1-0.6-0.1-1.2-0.1-1.8c0-10.6,8.6-19.3,19.3-19.3c5,0,9.8,2,13.3,5.3
                c3.6-3.4,8.3-5.3,13.3-5.3c10.6,0,19.3,8.6,19.3,19.3c0,0.6,0,1.2-0.1,1.8c7.8,2.5,13.4,9.9,13.4,18.4
                C130.1,50.7,121.4,59.4,110.8,59.4z M97.5,46.4c1,0,1.9,0.5,2.5,1.3c2.5,3.5,6.6,5.6,10.9,5.6c7.3,0,13.3-6,13.3-13.3
                c0-6.5-4.8-12.2-11.3-13.1c-0.8-0.1-1.6-0.6-2.1-1.3s-0.6-1.6-0.4-2.4c0.3-1.1,0.4-2.2,0.4-3.3c0-7.3-6-13.3-13.3-13.3
                c-4.3,0-8.4,2.1-10.9,5.6c-0.6,0.8-1.5,1.3-2.5,1.3s-1.9-0.5-2.5-1.3c-2.5-3.5-6.6-5.6-10.9-5.6c-7.3,0-13.3,6-13.3,13.3
                c0,1.1,0.1,2.2,0.4,3.3c0.2,0.8,0.1,1.7-0.4,2.4s-1.2,1.2-2.1,1.3c-6.4,1-11.3,6.6-11.3,13.1c0,7.3,6,13.3,13.3,13.3
                c4.3,0,8.4-2.1,10.9-5.6c0.6-0.8,1.5-1.3,2.5-1.3s1.9,0.5,2.5,1.3c2.5,3.5,6.6,5.6,10.9,5.6s8.4-2.1,10.9-5.6
                C95.6,46.9,96.5,46.4,97.5,46.4z"
          />
        </g>
        <g>
          <path
            class="st2"
            d="M60.1,78.5c-1.7,0-3-1.3-3-3v-2.9c0-1.7,1.3-3,3-3s3,1.3,3,3v2.9C63.1,77.1,61.8,78.5,60.1,78.5z"
          />
          <path
            class="st2"
            d="M84.2,78.5c-1.7,0-3-1.3-3-3v-2.9c0-1.7,1.3-3,3-3s3,1.3,3,3v2.9C87.2,77.1,85.8,78.5,84.2,78.5z"
          />
          <path
            class="st2"
            d="M108.2,78.5c-1.7,0-3-1.3-3-3v-2.9c0-1.7,1.3-3,3-3s3,1.3,3,3v2.9C111.2,77.1,109.8,78.5,108.2,78.5z"
          />
        </g>
        <g>
          <path
            class="st2"
            d="M72.2,94.3c-1.7,0-3-1.3-3-3v-2.9c0-1.7,1.3-3,3-3s3,1.3,3,3v2.9C75.2,92.9,73.8,94.3,72.2,94.3z"
          />
          <path
            class="st2"
            d="M96.2,94.3c-1.7,0-3-1.3-3-3v-2.9c0-1.7,1.3-3,3-3s3,1.3,3,3v2.9C99.2,92.9,97.8,94.3,96.2,94.3z"
          />
        </g>
      </g>
      <g>
        <path
          class="st2"
          d="M7.3,115.6c-0.1,1.1-0.1,2.1-0.2,4L7,142.5c3.1-0.8,5.9-2.3,8.1-4.4c2.7-2.5,4.6-5.3,6-9.2
            c1.2,2.1,1.5,2.6,2.8,4.1c-2,4.2-3.9,6.9-6.6,9.3c-3,2.7-6,4.2-10.8,5.5c-0.8,0.2-1.2,0.4-1.8,0.7l-1.9-3.1
            c0.2-1.1,0.3-1.8,0.3-4.1l0.1-21.6c0-2.8,0-2.8-0.1-4.1L7.3,115.6z"
        />
        <path
          class="st2"
          d="M26.5,128.9c1.3,0.2,1.9,0.3,4.8,0.3h15.8c2.9,0,3.5,0,4.8-0.3v5.6c-1.2-0.2-1.5-0.2-4.8-0.2H31.4
            c-3.3,0-3.6,0-4.8,0.2V128.9z"
        />
        <path
          class="st2"
          d="M77.5,121.8c-0.4,0.6-0.5,1-0.9,2.7c-3.5,13.1-8.1,20-17.1,25.6c-0.9-2-1.4-3-2.5-4.2
            c4.4-2.3,8.3-5.8,10.6-9.6c-1.8-2.1-4.2-4.4-6.1-5.7l2.2-3.6c2.3,1.8,3.9,3.2,6,5.4c1.2-2.4,2.5-6,3.3-9.4l-9.2,0.1
            c-1.6,3.8-4.2,7.8-6.9,10.8c-0.9-1.4-1.5-2-3-3.2c3-3,5.7-7.1,7.4-11.4c1-2.5,1.5-4.1,1.7-5.6l3.8,1.2c-0.3,0.8-0.4,0.8-0.9,2.3
            c-0.5,1.4-0.6,1.6-0.7,1.9c0.3,0,0.4,0,0.8-0.1H67l6.2-0.1c0.6,0,1.3-0.1,1.6-0.2c-0.7-1.8-1.2-2.9-2.1-4.5l2.3-0.9
            c1.2,2.1,1.9,3.7,2.7,6.2l-1.1,0.5L77.5,121.8z M79.4,119.1c-0.7-2.2-1.6-4.2-2.6-6.1l2.2-1c1.2,2,1.9,3.6,2.7,6L79.4,119.1z"
        />
        <path
          class="st2"
          d="M81.1,128.9c1.3,0.2,1.9,0.3,4.8,0.3h15.8c2.9,0,3.5,0,4.8-0.3v5.6c-1.2-0.2-1.5-0.2-4.8-0.2H85.9
            c-3.3,0-3.6,0-4.8,0.2V128.9z"
        />
        <path
          class="st2"
          d="M112.8,119c-1.7,0-2.6,0-3.6,0.2v-4.6c1,0.2,2,0.2,3.6,0.2h19.4c1.6,0,2.5-0.1,3.6-0.2v4.6
            c-1.2-0.2-2.1-0.2-3.6-0.2h-8.3v3.5h8c1.3,0,2,0,2.8-0.2c-0.1,1.1-0.1,2.1-0.1,3.7v19.4c0,3.6-0.8,4.5-4.2,4.5
            c-0.9,0-1.7,0-2.9-0.2c-0.2-2-0.3-2.8-0.8-4.4c1.2,0.3,2.5,0.5,3.5,0.5c1,0,1.2-0.2,1.2-1.1v-18.4h-7.5v18.3c0,2.2,0.1,3.4,0.2,5
            h-3.6c0.1-1.7,0.2-2.9,0.2-5v-18.3h-7.1v18.8c0,2.2,0.1,3.4,0.2,4.9h-3.6c0.1-1.8,0.2-3.1,0.2-4.9V126c0-1.4,0-2.6-0.1-3.7
            c0.9,0.1,1.7,0.2,2.9,0.2h7.4V119H112.8z M115.7,135.8c2.2,2.1,2.8,2.8,4.6,5.1l-2,3.3c-1.5-2.4-2.5-3.6-4.4-5.5L115.7,135.8z
             M116.2,127.4c1.9,1.8,2.7,2.6,4.2,4.5l-2,3c-1.5-2.2-2.6-3.4-4.3-4.8L116.2,127.4z M126,135.3c2.5,2.4,3.3,3.3,4.8,5.2l-2,3.1
            c-1.5-2.2-2.1-2.9-4.6-5.4L126,135.3z M126.3,127.4c2.1,1.8,3.1,2.8,4.8,4.9l-1.9,2.9c-1.1-1.7-1.2-1.7-4.6-5.2L126.3,127.4z"
        />
        <path
          class="st2"
          d="M137.7,125.8c0.9,0.2,1.6,0.2,3.1,0.2h20.7c1.5,0,2.3,0,3.1-0.2v3.5c-0.8-0.2-1.5-0.2-3-0.2h-20.8
            c-1.5,0-2.2,0-3.1,0.2V125.8z M143.7,140.4c-1.2,0-1.9,0-2.7,0.1c0.1-0.9,0.1-1.6,0.1-3.2v-4c0-1.3,0-2-0.1-3
            c0.7,0.1,1.4,0.2,2.8,0.2h14.8c1.3,0,2,0,2.8-0.2c-0.1,0.9-0.1,1.6-0.1,2.9v4.1c0,1.5,0,2.4,0.1,3.2c-0.8-0.1-1.7-0.1-2.7-0.1h-6
            v1.4h7.4c1.2,0,1.9,0,2.5-0.2v3.2c-0.7-0.1-1.5-0.2-2.6-0.2h-7.3v1.4h8.6c1.6,0,2.3,0,3.4-0.2v3.6c-1-0.2-2-0.2-3.4-0.2h-20.1
            c-1.4,0-2.3,0-3.4,0.2V146c1,0.2,1.7,0.2,3.4,0.2h8.4v-1.4h-6.9c-1.2,0-1.9,0-2.6,0.2v-3.2c0.6,0.1,1.2,0.2,2.5,0.2h7.1v-1.4
            H143.7z M143.4,124.6c-1.6,0-2.2,0-3,0.1c0.1-0.9,0.1-1.8,0.1-3.3v-3.8c0-1.4,0-2.2-0.1-3.2c0.9,0.1,1.7,0.2,3.1,0.2h15.3
            c1.5,0,2.2,0,3.1-0.2c-0.1,1-0.1,1.6-0.1,3.2v3.8c0,1.4,0,2.4,0.1,3.3c-0.8-0.1-1.4-0.1-3-0.1H143.4z M143.5,122h15.2v-1.3h-15.2
            V122z M143.5,118.4h15.2v-1.3h-15.2V118.4z M144.1,133.1v1.4h5.4v-1.4H144.1z M144.1,136.7v1.3h5.4v-1.3H144.1z M152.6,134.5h5.7
            v-1.4h-5.7V134.5z M152.6,138h5.7v-1.3h-5.7V138z"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {};
</script>
<style lang="scss">
.st0 {
  display: none;
}
.st1 {
  fill: #ffffff;
}
.st2 {
  fill: #3041a5;
}
</style>